import produce from 'immer';

// UTILS
import { toSelect } from 'utils/genericFunctions';

// TYPES
import { Types, ConsultaPaises } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: ConsultaPaises = {
	status: 0,
	data: [],
};

export default function consultaPaisesReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaPaises {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_PAISES_REQUEST: {
				break;
			}
			case Types.CONSULTA_PAISES_SUCCESS: {
				draft.status = action.payload.status;
				const lista = toSelect(action.payload.data, 'nome', 'codigo');

				draft.data = [...lista];
				break;
			}
			case Types.CONSULTA_PAISES_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
